import React from 'react'
import ContactBanner from './ContactBanner'
import ContactForm from './ContactForm'
import ProjectStats from '../../Common/ProjectStats/ProjectStats'
import TestimonialSlider from '../../Common/TestimonialSlider/TestimonialSlider'

function ContactUs() {
  return (
    <div>
      <ContactBanner/>
      <ContactForm/>
      <ProjectStats/>
      <TestimonialSlider/>
    </div>
  )
}

export default ContactUs
